import React, { useMemo } from 'react';
import { FaDatabase, FaFlask, FaTint, FaBook, FaRulerHorizontal } from 'react-icons/fa';

const uniqueNonEmpty = (data, key) => {
    const set = new Set();
    data.forEach(row => {
        const val = row[key];
        if (val && val !== '-') set.add(val);
    });
    return set.size;
};

const avgNumeric = (data, key) => {
    const nums = data
        .map(row => parseFloat(row[key]))
        .filter(n => !isNaN(n));
    if (nums.length === 0) return null;
    return nums.reduce((s, n) => s + n, 0) / nums.length;
};

export default function DatasetSummaryStats({ data, totalUnfiltered }) {
    const stats = useMemo(() => {
        const avgFiber = avgNumeric(data, 'Fiber Diameter (nm)');
        return {
            records: data.length,
            polymers: uniqueNonEmpty(data, 'Polymer Name(s)'),
            solvents: uniqueNonEmpty(data, 'Solvent Name(s)'),
            papers: uniqueNonEmpty(data, 'DOI'),
            avgFiber: avgFiber !== null ? Math.round(avgFiber) : null,
        };
    }, [data]);

    if (!data || data.length === 0) return null;

    const isFiltered = typeof totalUnfiltered === 'number' && totalUnfiltered !== stats.records;

    const tiles = [
        { icon: <FaDatabase />, value: stats.records.toLocaleString(), label: isFiltered ? `of ${totalUnfiltered.toLocaleString()} records` : 'Records' },
        { icon: <FaFlask />, value: stats.polymers.toLocaleString(), label: 'Unique Polymers' },
        { icon: <FaTint />, value: stats.solvents.toLocaleString(), label: 'Unique Solvents' },
        { icon: <FaBook />, value: stats.papers.toLocaleString(), label: 'Source Publications' },
    ];

    if (stats.avgFiber !== null) {
        tiles.push({ icon: <FaRulerHorizontal />, value: `${stats.avgFiber} nm`, label: 'Avg. Fiber Diameter' });
    }

    return (
        <div className="dataset-summary-strip mb-3">
            {tiles.map((tile, i) => (
                <div className="dataset-summary-tile" key={i}>
                    <span className="dataset-summary-icon">{tile.icon}</span>
                    <div className="dataset-summary-text">
                        <div className="dataset-summary-value">{tile.value}</div>
                        <div className="dataset-summary-label">{tile.label}</div>
                    </div>
                </div>
            ))}
        </div>
    );
}
